var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"img",staticStyle:{"float":"left"}},[_c('img',{attrs:{"height":_vm.heightpx,"src":_vm.src}})]),_vm._v(" "),_c('div',{staticClass:"txt"},[_vm._t("txt")],2),_vm._v(" "),_c('div',{staticClass:"footer",staticStyle:{"clear":"both","text-align":"center","padding-top":"30px"}},[_vm._t("foot")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b6c0d6a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ImageLeft.vue
// module id = 2812
// module chunks = 1